import React, { Fragment } from 'react';
import { storiesOf } from '@storybook/react-native';
import { action } from '@storybook/addon-actions';
import { View, ScrollView } from 'react-native';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { PanelHeader } from 'src/components/PanelHeader';
import PlusIcon from 'src/assets/icons/plus.svg';
import ChevronRight from 'src/assets/icons/chevron-right.svg';
import TwitterIcon from 'src/assets/icons/twitter.svg';
import GlobeIcon from 'src/assets/icons/globe.svg';
import { Button } from 'src/components/Button';

const Wrapper: React.FC = ({ children }) => (
  <PlatformPadding horizontal vertical>
    <View>{children}</View>
  </PlatformPadding>
);

storiesOf('Button', module)
  .add('Primary', () => (
    <ScrollView>
      <PanelHeader>🖲 Button</PanelHeader>
      <Wrapper>
        <Button variant="primary" size="l" onPress={action('onPress')}>
          Button L
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="primary" size="m" onPress={action('onPress')}>
          Button M
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="primary" size="s" onPress={action('onPress')}>
          Button S
        </Button>
      </Wrapper>

      <Wrapper>
        <Button variant="secondary" size="l" onPress={action('onPress')}>
          Button L
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="secondary" size="m" onPress={action('onPress')}>
          Button M
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="secondary" size="s" onPress={action('onPress')}>
          Button S
        </Button>
      </Wrapper>

      <Wrapper>
        <Button variant="tertiary" size="l" onPress={action('onPress')}>
          Button L
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="tertiary" size="m" onPress={action('onPress')}>
          Button M
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="tertiary" size="s" onPress={action('onPress')}>
          Button S
        </Button>
      </Wrapper>

      <Wrapper>
        <Button variant="outline" size="l" onPress={action('onPress')}>
          Button L
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="outline" size="m" onPress={action('onPress')}>
          Button M
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="outline" size="s" onPress={action('onPress')}>
          Button S
        </Button>
      </Wrapper>
    </ScrollView>
  ))
  .add('With icon', () => (
    <Fragment>
      <PanelHeader>🖲 With Icon</PanelHeader>
      <Wrapper>
        <Button variant="primary" before={<PlusIcon />} onPress={action('onPress')}>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi doloribus, enim est
          excepturi explicabo facilis inventore ipsa magni necessitatibus odio possimus praesentium
          quo reprehenderit sit sunt temporibus tenetur unde voluptates!
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="primary" before={<PlusIcon />} onPress={action('onPress')}>
          Button
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="secondary" before={<TwitterIcon />} onPress={action('onPress')}>
          Button
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="outline" before={<GlobeIcon />} onPress={action('onPress')}>
          Button
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="primary" after={<ChevronRight />} onPress={action('onPress')}>
          Button
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="secondary" after={<ChevronRight />} onPress={action('onPress')}>
          Button
        </Button>
      </Wrapper>
      <Wrapper>
        <Button variant="outline" after={<ChevronRight />} onPress={action('onPress')}>
          Button
        </Button>
      </Wrapper>
    </Fragment>
  ));
